import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Title } from "../../utils/style/elements.tsx";
import ak_portfolio from "../../datas/ak_portfolioData.js";
import cw_flyer from "../../datas/cw_flyerData.js";
import jj_card from "../../datas/jj_cardData.js";
import jj_flyer from "../../datas/jj_flyerData.js";
import al_card from "../../datas/al_cardData.js";
import mulligan_site from "../../datas/mulliganData.js";
import clipweb_site from "../../datas/clipwebSiteData.js";
import colors from "../../utils/style/colors.tsx";
import { Transition } from "../../utils/style/transition.tsx";

const PageContainer = styled.div``;

const Page404 = styled.div`
    margin-top: 250px;
`;

const SectionTitle = styled.div``;

const SectionPrincipale = styled.div`
    background-color: ${colors.light_pink};
    margin-top: -34px;
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 200px;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        margin-top: -20px;
        padding-top: 150px;
        padding-left: 5%;
        padding-right: 5%;
    }
`;

const Section = styled.div`
    margin-bottom: 70px;
    padding-left: 10%;
    padding-right: 10%;

    @media (max-width: 900px) {
        margin-bottom: 30px;
        padding-left: 5%;
        padding-right: 5%;
    }
`;

const SectionContent = styled.div`
    display: flex;
    gap: 130px;

    @media (max-width: 900px) {
        flex-direction: column;
        gap: 20px;
    }
`;

const ImgTitreContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 5%;
    margin-top: 50px;

    @media (max-width: 768px) {
        margin-top: 30px;
    }
`;

const ImgTitre = styled.img`
    max-width: 70%;
    max-height: 65vh;

    @media (max-width: 768px) {
        max-width: 90%;
    }
`;

const LargeTextContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
`;

const TextContainer = styled.div`
    display: flex;
    width: 50%;
    align-items: start;

    @media (max-width: 900px) {
        width: 100%;
    }
`;

const Texte = styled.p`
    font-size: 24px;
    line-height: 1.6;

    @media (max-width: 768px) {
        font-size: 16px !important;
    }
`;

const StyledTexte = styled(Texte)`
    width: 100%;
    margin: 0;
    font-family: "Inter", sans-serif;

    @media (max-width: 1150px) {
        font-size: 20px;
    }
`;

const ProjectImgContainer = styled.div`
    width: 50%;
    display: flex;
    align-items: center;

    @media (max-width: 900px) {
        width: 100%;
        justify-content: center;
    }
`;

const ProjectImage = styled.img`
    width: 100%;
    object-fit: contain;

    @media (max-width: 900px) {
        width: 80%;
    }
`;

const VideoContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;

    iframe {
        @media (max-width: 768px) {
            width: 100%;
            height: 200px;
        }
    }
`;

const LinkContainer = styled.div`
    width: 100%;
    display: flex;
    color: ${colors.red};
`;

const LinkUl = styled.ul`
    @media (max-width: 1150px) {
        padding-left: 20px;
    }
`;

const LinkLi = styled.li`
    margin-bottom: 20px;
`;

const LinkLien = styled.a`
    color: ${colors.red};
    text-decoration: none;
    font-size: 24px;
    word-break: break-word;

    &:hover {
        border-bottom: solid 2px ${colors.red};
    }

    @media (max-width: 1150px) {
        font-size: 20px;
    }

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const TextTitreWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

const projectDatas = {
    "Portfolio_Alexandre_Kotowicz_React": ak_portfolio,
    "Clip_Web_Flyer_Digital": cw_flyer,
    "Clip_Web_Site": clipweb_site,
    "JJ_Detailing_Carte_Visite": jj_card,
    "JJ_Detailing_Flyer": jj_flyer,
    "AL_Batiment_Carte_Visite": al_card,
    "Mulligan_TCG_Site_Web": mulligan_site,
};

function ProjectPage() {
    const { slug } = useParams();
    const project = projectDatas[slug];

    if (!project) {
        return (
            <Page404>
                <Section>
                    <Title>Cette page n'existe pas 🦁</Title>
                    <StyledTexte>Le projet que vous recherchez n'a pas été trouvé.</StyledTexte>
                </Section>
            </Page404>
        );
    }

    return (
        <PageContainer>
            {project.sections.map((section, index) => {
                const isFirstSection = index === 0;

                // Traitement du contenu
                const titleElement = section.elements.find(el => el.type === "title");
                const imgTitleElement = section.elements.find(el => el.type === "imageTitle");
                const textElements = section.elements.filter(el => el.type === "text");
                const contentElements = section.elements.filter(el => !["title", "imageTitle"].includes(el.type));

                const hasMedia = section.elements.some(el => 
                    el.type === "image" || el.type === "video" || el.type === "link"
                );

                const isSectionPrincipale = section.elements.some(el => el.type === "title-prc");

                const sectionContent = isSectionPrincipale ? (
                    <>
                        {(() => {
                            let contentRendered = false;
                            return section.elements.map((element, idx) => {
                                if (!contentRendered && (element.type === "title-prc" || element.type === "tex-prc")) {
                                    contentRendered = true;
                                    const title = section.elements.find(el => el.type === "title-prc");
                                    const text = section.elements.find(el => el.type === "tex-prc");

                                    return (
                                        <TextTitreWrapper key={"text-wrapper"}>
                                            {title && <Title>{title.content}</Title>}
                                            {text && (
                                                <LargeTextContainer>
                                                    <StyledTexte>{text.content}</StyledTexte>
                                                </LargeTextContainer>
                                            )}
                                        </TextTitreWrapper>
                                    );
                                }

                                if (element.type === "imageTitle") {
                                    // Gérer les images placeholder
                                    if (element.src === "placeholder") {
                                        return (
                                            <ImgTitreContainer key={idx}>
                                                <div style={{
                                                    width: '70%',
                                                    maxWidth: '600px',
                                                    height: '400px',
                                                    backgroundColor: colors.light_pink,
                                                    border: `solid 7px ${colors.black}`,
                                                    borderRadius: '20px',
                                                    boxShadow: `7px 7px ${colors.black}`,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '18px',
                                                    color: colors.black,
                                                    textAlign: 'center',
                                                    padding: '20px',
                                                    fontFamily: 'Inter, sans-serif'
                                                }}>
                                                    {element.alt}
                                                </div>
                                            </ImgTitreContainer>
                                        );
                                    }
                                    
                                    return (
                                        <ImgTitreContainer key={idx}>
                                            <ImgTitre src={element.src} alt={element.alt} />
                                        </ImgTitreContainer>
                                    );
                                }

                                return null;
                            });
                        })()}
                    </>
                ) : (
                    <>
                        {titleElement && (
                            <SectionTitle>
                                <Title>{titleElement.content}</Title>
                                {isFirstSection && imgTitleElement && (
                                    <ImgTitreContainer>
                                        <ImgTitre
                                            src={imgTitleElement.src}
                                            alt={imgTitleElement.alt}
                                        />
                                    </ImgTitreContainer>
                                )}
                            </SectionTitle>
                        )}

                        {textElements.length > 0 && !hasMedia && (
                            <LargeTextContainer>
                                {textElements.map((text, idx) => (
                                    <StyledTexte key={idx}>
                                        {text.content}
                                    </StyledTexte>
                                ))}
                            </LargeTextContainer>
                        )}

                        {contentElements.some(el => el.type === "link") && (
                            <LinkContainer>
                                <LinkUl>
                                    {contentElements
                                        .filter(el => el.type === "link")
                                        .map((element, idx) => (
                                            <LinkLi key={idx}>
                                                <LinkLien
                                                    href={element.content}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {element.content}
                                                </LinkLien>
                                            </LinkLi>
                                        ))}
                                </LinkUl>
                            </LinkContainer>
                        )}

                        {hasMedia && (
                            <SectionContent>
                                {contentElements.map((element, idx) => (
                                    <React.Fragment key={idx}>
                                        {element.type === "text" && (
                                            <TextContainer>
                                                <StyledTexte>{element.content}</StyledTexte>
                                            </TextContainer>
                                        )}

                                        {element.type === "image" && (
                                            <ProjectImgContainer>
                                                <ProjectImage
                                                    src={element.src}
                                                    alt={element.alt}
                                                />
                                            </ProjectImgContainer>
                                        )}

                                        {element.type === "video" && (
                                            <VideoContainer>
                                                <iframe
                                                    width="700px"
                                                    height="400px"
                                                    src={element.src}
                                                    title="Video"
                                                    frameBorder="0"
                                                    allowFullScreen
                                                />
                                            </VideoContainer>
                                        )}
                                    </React.Fragment>
                                ))}
                            </SectionContent>
                        )}
                    </>
                );

                return isFirstSection ? (
                    <React.Fragment key={index}>
                        <SectionPrincipale>
                            {sectionContent}
                        </SectionPrincipale>
                        <Transition theme="rose" orientation="0deg" />
                    </React.Fragment>
                ) : (
                    <Section key={index}>
                        {sectionContent}
                    </Section>
                );
            })}
        </PageContainer>
    );
}

export default ProjectPage;